module.exports = __webpack_public_path__ + "static/img/xinchuang-icon.7c799d6c.png";